module.exports = __webpack_public_path__ + "static/media/cardif-white.6d2b33b7.svg";